// One cell of the Win % / Odds columns, centred so a value sits under its
// label whatever its width.
export const winOddsCellStyle = { flex: 1, textAlign: "center" as const };
